import React from 'react'

import AdminRoute from './admin'
import PrivateRoute from './private'
import PublicRoute from './public'
import SistemaConfigs from './sistema'


const config = {
    subConfig: [SistemaConfigs,PublicRoute, PrivateRoute, AdminRoute]
}


export default config



// WEBPACK FOOTER //
// ./src/routes/index.js